import type React from "react";
import { createElement } from "react";
import type { StyleObject } from "../../theme/styled";
import { css } from "../../theme/styled";
import { joinClassNames } from "../../util/util";

interface Props {
  className?: string;
  "aria-label"?: string;
  alignItems?: StyleObject["alignItems"];
  alignContent?: StyleObject["alignContent"];
  justifyContent?: StyleObject["justifyContent"];
  direction?: StyleObject["flexDirection"];
  alignSelf?: StyleObject["alignItems"];
  wrap?: StyleObject["flexWrap"];
  order?: StyleObject["order"];
  gap?: StyleObject["gap"];
  flex?: StyleObject["flex"];
  inline?: boolean;
  component?: keyof React.JSX.IntrinsicElements;
  style?: StyleObject;
  onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => unknown;
  dataComponentType?: string;
  children?: React.ReactNode;
  "data-test-id"?: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const Flex = (props: Props) => {
  const internalClassName = css({
    alignContent: props.alignContent,
    alignItems: props.alignItems,
    justifyContent: props.justifyContent,
    flexDirection: props.direction,
    flexWrap: props.wrap,
    alignSelf: props.alignSelf,
    gap: props.gap,
    flex: props.flex,
    order: props.order,
    display: props.inline ? "inline-flex" : "flex",
    ...props.style,
  });

  const component = props.component || "div";

  return createElement(
    component,
    {
      className: joinClassNames([internalClassName, props.className]),
      onClick: props.onClick,
      "data-component-type": props.dataComponentType,
      "data-test-id": props["data-test-id"],
      "aria-label": props["aria-label"],
    },
    props.children,
  );
};
